import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Home, Search } from "lucide-react";
import { useSite } from "../lib/store";
import { Daisy, FlowerBlob } from "../components/Daisy";
import { useSeo } from "../components/Seo";

export default function NotFound() {
  useSeo({ title: "Stránka nenalezena (404)", noindex: true });
  const { site } = useSite();
  return (
    <section className="relative overflow-hidden px-5 py-20 text-center sm:py-28" data-testid="not-found-page">
      <FlowerBlob className="animate-spin-slow absolute left-1/2 top-6 h-80 w-80 -translate-x-1/2 opacity-30" />
      <motion.div initial={{ scale: 0, rotate: -90 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: "spring", damping: 12 }} className="relative mx-auto grid h-36 w-36 place-items-center rounded-full bg-[#A3AC86]">
        <Daisy size={100} className="animate-wiggle" />
      </motion.div>
      <h1 className="h-display relative mt-8 text-6xl sm:text-7xl">404</h1>
      <p className="relative mt-3 font-script text-2xl text-[#D96B43]">Tahle stránka uletěla jako okvětní lístek.</p>
      <p className="relative mx-auto mt-3 max-w-md text-[#6E7565]">Stránku jsme nenašli. Možná byla přesunuta nebo už neexistuje. Zkuste některou z těchto cest:</p>
      <div className="relative mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="btn-sage" data-testid="notfound-home-btn"><Home className="h-4 w-4" /> Domů</Link>
        <Link to="/eshop" className="btn-ghost" data-testid="notfound-shop-btn"><Search className="h-4 w-4" /> Do e-shopu</Link>
      </div>
      <div className="relative mx-auto mt-10 flex max-w-2xl flex-wrap justify-center gap-2">
        {(site?.categories || []).map((c) => (
          <Link key={c.id} to={`/kategorie/${c.slug}`} className="flex items-center gap-1 rounded-full bg-white px-4 py-2 text-sm hover:bg-[#E9EFE0]">{c.name} <ArrowRight className="h-3 w-3" /></Link>
        ))}
      </div>
    </section>
  );
}
